require('./capability_ng_resources_module.ts');
require('./builders/resource_builder.ts');
require('./builders/resource_category_builder.es.js');
require('./builders/resource_category_builder.ts');
require('./builders/resource_detail_builder.ts');
require('./builders/resource_details_builder.es.js');
require('./builders/resource_info_builder.ts');
require('./builders/resource_location_builder.es.js');
require('./builders/resource_location_builder.ts');
require('./builders/resources_list_builder.es.js');
require('./commands/favorite_resource_command.es.js');
require('./commands/load_contacts_command.ts');
require('./commands/load_resource_categories_command.ts');
require('./commands/load_resource_detail_command.ts');
require('./commands/load_resources_command.ts');
require('./commands/unfavorite_resource_command.es.js');
require('./components/people/contact_card/contact_card.ts');
require('./components/people/contact_detail/contact_detail_controller.ts');
require('./components/people/contact_list/contact_list_controller.ts');
require('./components/people/contact_tile_availability/contact_tile_availability_controller.ts');
require('./components/places/resource_detail_content/resource_detail_content.ts');
require('./components/places/resource_detail_item/resource_detail_item.ts');
require('./contact_interfaces.ts');
require('./datasources/contacts_datastore.ts');
require('./datasources/resource_category_datastore.ts');
require('./datasources/resource_datastore.ts');
require('./datasources/resource_info_datastore.ts');
require('./datasources/resource_location_datastore.ts');
require('./models/resource_category_model.es.js');
require('./models/resource_model.es.js');
require('./models/contacts_search_model.ts');
require('./models/resource_search_model.ts');
require('./queries/contacts_relationship_query.ts');
require('./queries/resource_category_query.ts');
require('./queries/resource_list_query.ts');
require('./resources_interface.ts');
require('./servants/location_link_builder_servant.ts');
require('./servants/resource_list_servant.ts');
require('./services/contact_list_service.ts');
require('./services/contact_service.ts');
require('./services/contact_toggle_service.ts');
require('./types/resource_link_enum.es.js');
require('./types/resource_tab_enum.ts');



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-resources/src/core.ts